<script lang="ts">
	import type { TooltipOptions } from '$lib/actions/tooltip/types';
	import type { IconName } from '$lib/components/icons/types';
	import type { ClassValue } from 'svelte/elements';
	import { tooltip } from '$lib/actions/tooltip/tooltip';
	import Icon from '$lib/components/icons/Icon.svelte';

	interface Props {
		icon?: IconName;
		amount: number;
		ariaLabel?: string;
		tooltipOptions?: TooltipOptions;
		style?: 'currency' | 'distinction' | 'grade';
		tag?: string;
		iconTag?: string;
		class?: ClassValue;
		iconClasses?: ClassValue;
	}

	const {
		icon,
		amount,
		ariaLabel,
		tooltipOptions,
		style,
		tag = 'div',
		iconTag = 'div',
		class: classes,
		iconClasses,
	}: Props = $props();

	const margins = {
		currency: 'mx--0.75',
		distinction: 'mx--0.25',
		grade: 'mx--0.5',
	};
</script>

<svelte:element this={tag} class={['flex row w-max', classes]} use:tooltip={tooltipOptions}>
	{#each { length: amount } as _, index (index)}
		<Icon {icon} {ariaLabel} class={[style && margins[style], iconClasses]} tag={iconTag} />
	{/each}
</svelte:element>
